import React from 'react';
import { Controller } from 'react-hook-form';
import { TextField } from '@mui/material';
import { CurrencyInput } from 'react-currency-mask';

const FieldCurrency = ({ control, name, label, rules, disabled }) => {
  return (
    <Controller
      name={name}
      control={control}
      // defaultValue={0}
      rules={{
        ...rules,
        required: 'Amount is required',
        // validate: (value) => {
        //   // Remove formatting characters and validate numeric value
        //   const numericValue = Number(value.replace(/[^0-9.-]+/g, ''));
        //   return !isNaN(numericValue) || 'Please enter a valid amount';
        // },
      }}
      render={({ field, fieldState }) => (
        <CurrencyInput
          value={field.value}
          currency={'EUR'}
          onChangeValue={(_, value) => {
            field.onChange(value);
          }}
          InputElement={
            <TextField
              {...field}
              label={label}
              variant="filled"
              fullWidth
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              disabled={disabled}
            />
          }
        />
      )}
    />
  );
};

export default FieldCurrency;
